module.exports = __webpack_public_path__ + "static/assets/7e3072523a8d32d2eb49bad788dfa11c.gif";